<template>
  <div class="page">
    <div class="toolbar">
      <div class="actions">
        <el-button type="primary" @click="openForm(0)">+ 新建顶级部门</el-button>
      </div>
    </div>

    <el-card>
      <el-table stripe :data="tree" row-key="id" :tree-props="{ children: 'children' }" default-expand-all border>
        <el-table-column prop="deptName" label="部门名称" min-width="200">
          <template #default="{ row }">
            <el-icon><OfficeBuilding /></el-icon>
            <span style="margin-left: 6px">{{ row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="排序号" width="80" align="center" />
        <el-table-column label="状态" width="80" align="center">
          <template #default="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" />
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{ row }">
            <el-button link type="primary" size="small" @click="openForm(row.id)">编辑</el-button>
            <el-button link type="primary" size="small" @click="openForm(0, row.id)">+ 子部门</el-button>
            <el-button link type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="480px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="上级部门">
          <el-tree-select v-model="form.parentId" :data="treeForSelect"
                          :props="{ label: 'deptName', value: 'id' }"
                          placeholder="顶级部门" clearable check-strictly />
        </el-form-item>
        <el-form-item label="部门名称" required>
          <el-input v-model="form.deptName" placeholder="请输入部门名称" />
        </el-form-item>
        <el-form-item label="排序号">
          <el-input-number v-model="form.orderNo" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :value="1">启用</el-radio>
            <el-radio :value="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="200" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { OfficeBuilding } from '@element-plus/icons-vue'
import request from '../utils/request'

const tree = ref([])
const dialogVisible = ref(false)
const submitting = ref(false)
const form = ref({ id: null, parentId: 0, deptName: '', orderNo: 0, status: 1, remark: '' })

const treeForSelect = computed(() => {
  // 树选择器需要包含一个"顶级"选项
  return [{ id: 0, deptName: '顶级部门', children: tree.value }]
})

const flatList = computed(() => flatten(tree.value))

function flatten(nodes, level = 0) {
  const out = []
  nodes.forEach(n => {
    out.push(n)
    if (n.children && n.children.length) out.push(...flatten(n.children, level + 1))
  })
  return out
}

const dialogTitle = computed(() => form.value.id ? '编辑部门' : '新建部门')

async function loadTree() {
  const res = await request.get('/dept/tree')
  tree.value = res.data || []
}

function openForm(id, parentId) {
  if (id) {
    const row = flatList.value.find(d => d.id === id)
    form.value = { ...row }
  } else {
    form.value = { id: null, parentId: parentId || 0, deptName: '', orderNo: 0, status: 1, remark: '' }
  }
  dialogVisible.value = true
}

async function handleSave() {
  if (!form.value.deptName?.trim() || submitting.value) return
  submitting.value = true
  try {
    await request.post('/dept/save', form.value)
    ElMessage.success('保存成功')
    dialogVisible.value = false
    await loadTree()
  } finally {
    submitting.value = false
  }
}

async function handleDelete(row) {
  try {
    await ElMessageBox.confirm(`确定删除「${row.deptName}」吗？`, '删除确认', { type: 'warning' })
    await request.delete(`/dept/${row.id}`)
    ElMessage.success('删除成功')
    await loadTree()
  } catch (e) {
    if (typeof e === 'string') ElMessage.error(e)
  }
}

onMounted(loadTree)
</script>

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.actions { display: flex; gap: 8px; }
</style>
